import React, { createContext } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { globalStores, GlobalStoreContext } from "./api/globalStores";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { HMSRoomProvider } from "@100mslive/react-sdk";
import { HMSTalkingPartySessionStore } from "./Common/Utility/helpers";
import { PostHogProvider } from "posthog-js/react";

Sentry.init({
  dsn: "https://61e71255a86549df8941b30e13197a81@o4504172969918464.ingest.sentry.io/4504172971950080",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.2,
});
Sentry.setTag("app", "beta-frontend");

const TypedHMSRoomProvider = HMSRoomProvider<{
  sessionStore: HMSTalkingPartySessionStore;
}>;

const isLocal =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");
const posthogDisabled =
  isLocal || process.env.REACT_APP_DISABLE_POSTHOG === "true";

// leaveOnUnload={false}: react-sdk 0.12.x broadened the SDK's own leave handler
// from "unload" to "pagehide" + "beforeunload" + "freeze". "freeze" fires when
// Chromium freezes a long-hidden tab and "pagehide" fires on bfcache entry, so a
// student who backgrounds the app mid-lesson could be dropped from the room.
// 0.13.x narrowed it again (no "freeze", no leave while hidden or on a bfcache
// pagehide) but still leaves on provider unmount, and the prop still gates both.
// RedirectHandler (App.tsx) already registers an "unload" leave on every route,
// which is the pre-0.12 behaviour we want to keep.
const app = (
  <TypedHMSRoomProvider leaveOnUnload={false}>
    <App />
  </TypedHMSRoomProvider>
);

ReactDOM.render(
  <GlobalStoreContext.Provider value={globalStores}>
    <React.StrictMode>
      {posthogDisabled ? (
        app
      ) : (
        <PostHogProvider
          apiKey={process.env.REACT_APP_POSTHOG_KEY || ""}
          options={{
            api_host: process.env.REACT_APP_POSTHOG_HOST,
            defaults: "2025-05-24",
            capture_exceptions: true,
            debug: false,
          }}
        >
          {app}
        </PostHogProvider>
      )}
    </React.StrictMode>
  </GlobalStoreContext.Provider>,
  document.getElementById("root")
);

reportWebVitals();